import React, { Component, Fragment, forwardRef } from "react";
import moment from "moment";
import { get } from "../../utils/DeApi";
import {
  Row,
  Col,
  Container,
  Table,
  Button,
  Alert,
  InputGroup,
  Modal,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Popover,
  Overlay,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Header from "../App/Header/Header";
import FilingPreview from "../Filing/FilingPreview/FilingPreview";
import Loader from "../Loader/Loader";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import { orderBy } from "lodash";
import EmailBoxIcon from "mdi-react/EmailBoxIcon";
import NotebookEditOutlineIcon from "mdi-react/NotebookEditOutlineIcon";

import "./Dashboard.scss";
import { documentSize } from "../../utils/StringUtils";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filedAt: moment().utc().subtract(1, "day").format("YYYYMMDD"),
      isLoading: false,
      filings: [],
      error: null,
      sortable: props?.sortable || false,
      filings: props?.filings || [],
      sortColumnMapping: {
        Company: { column: "companyNameLong", direction: "desc" },
        CIK: { column: "cik", direction: "desc" },
        "Accession No": { column: "accessionNo", direction: "desc" },
        "Fetched At": { column: "fetchedAtDate", direction: "desc" },
        "Filed At": { column: "filedAt", direction: "desc" },
      },
      sortBy: "",
      sortSelection: {},
      modalOpen: false,
      name: "React",
      documentId: null,
      documentUrl: null,
      modalOpen: false,
      docContents: null,
      selectedFiling: null,
      selectedDoc: null,
      selectedItemId: null,
      openMail: false,
      search: [],
      target: null,
    };

    this.divRef = React.createRef();

    this.onChangeValue = this.onChangeValue.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenMail = this.handleOpenMail.bind(this);
    this.searchFilings = this.searchFilings.bind(this);
    this.sortDataByBtn = this.sortDataByBtn.bind(this);
  }

  handleClick = (element, docs) => {
    localStorage.setItem("filings", element.linkToFilings);
    localStorage.setItem("documentId", docs.documentId);
    localStorage.setItem("documentUrl", docs.documentUrl);
  };

  handleOpenModal(doc) {
    this.setState({
      modalOpen: true,
      selectedDoc: doc,
      selectedItemId: doc?.id || -1,
    });
  }

  handleSelectedDocument(element, filing, mailing = false) {
    this.setState(
      {
        modalOpen:
          this.state.target === element.target ? !this.state.modalOpen : true,
        target: element.target,
        selectedDoc: filing,
        selectedItemId: filing?.id || -1,
      },
      () => {}
    );

    if (mailing) {
      this.handleOpenMail(filing);
    }
  }

  getDocumentFormatFiles() {
    const { selectedDoc } = this.state;

    let buttons = null;
    if (selectedDoc !== null) {
      buttons =
        selectedDoc.formType === "N-54C" ? (
          <React.Fragment>
            <div className="row">
              <div className="col-sm-12">
                <label for="email">Write an Email:</label>
              </div>
              <div className="col-sm-12">
                <textarea
                  id="email"
                  name="email"
                  rows="4"
                  cols="50"
                  className="form-control"
                ></textarea>
              </div>
              <div className=" mt-3 col-sm-12">
                <Button
                  variant="default"
                  size="sm"
                  className="btn btn-success-deal-style roundedEdges"
                >
                  Sent
                </Button>
              </div>
            </div>
          </React.Fragment>
        ) : (
          selectedDoc.documentFormatFiles.map((doc, indx) => (
            <Button
              key={"random_key_" + indx + Math.random().toString()}
              id={`linkButton${doc.documentId}`}
              size="sm"
              variant="default"
              style={{ marginRight: "1%" }}
              className="border shadow-sm"
              onClick={() => this.handleClick(doc, doc)}
            >
              <Link
                className="documentClass font-weight-bold"
                key={"random_key_" + indx + Math.random().toString()}
                to={{
                  pathname: "/Bdc",
                  state: { filings: selectedDoc, docs: doc },
                }}
              >
                {doc?.type}
              </Link>
            </Button>
          ))
        );
    }
    return buttons;
  }

  handleCloseModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
      selectedItemId: null,
    });
  }

  handleOpenMail = (filing) => {
    const to = "someone@example.com";
    const subject = `Closure of BDC ${filing.companyName}`;
    const documentUrl = filing.documentFormatFiles[0].documentUrl; // access the first object in the array
    const body = `Hi Team, %0A %0A

As mentioned in the subject, ${filing.companyName} has filed the N-54C form.%0A %0A

Following is the link to its Closure form.
${documentUrl}.%0A %0A
Kindly confirm if we can mark this BDC as inactive on our system?`;
    const bcc = "someone.else@example.com";
    const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;
    window.open(url, "_blank");
  };
  onChangeValue(event) {
    console.log(event.target.value);
  }

  componentDidMount() {
    this.fetchBDCFilings();
  }

  fetchBDCFilings() {
    const { filedAt } = this.state;
    const esIndex = process.env.REACT_APP_BDC_ES;
    this.setState({ error: null, isLoading: true });
    const searchFilingsPromise = get("/search/filings", {
      params: {
        q: `filedAtDate:${moment(filedAt).format("YYYY-MM-DD")}`,
        formType: [
          "N-54A",
          "N-54C",
          "8-K",
          "8-K/A",
          "10-Q",
          "10-Q/A",
          "10-K",
          "10-K/A",
          "N-2",
          "N-2A",
          "CERT",
        ],
        offset: 0,
        limit: 5000,
        indexing: esIndex,
      },
    });

    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filings: response.data,
          search: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ error: error, isLoading: false });
      });
  }

  handleSortBy = (title) => {
    let { sortColumnMapping, sortSelection } = this.state;
    sortColumnMapping = {
      ...sortColumnMapping,
      [title]: {
        ...sortColumnMapping[title],
        direction:
          sortColumnMapping[title].direction === "asc" ? "desc" : "asc",
      },
    };
    sortSelection = {
      ...sortSelection,
      [title]: sortColumnMapping[title],
    };
    this.setState(
      {
        sortColumnMapping: sortColumnMapping,
        sortBy: title,
        sortSelection: sortSelection,
      },
      () => {
        this.sortData();
      }
    );
  };

  sortData = () => {
    if (this.state.sortBy !== "") {
      const { sortColumnMapping, filings, search } = this.state;
      const column = sortColumnMapping[this.state.sortBy].column;
      const direction = sortColumnMapping[this.state.sortBy].direction;
      this.setState({
        filings: orderBy(filings, column, direction),
        search: orderBy(search, column, direction),
      });
    }
  };

  sortDataByBtn = (value) => {
    // checking if any of the filings is the latest file.
    const isLatestFile = this.state.search.some(
      (filing) => filing.isLatestFile
    );

    if (isLatestFile) {
      // sortby createdAt
      this.setState({
        filings: orderBy(this.state.filings, ["createdAt"], value),
        search: orderBy(this.state.search, ["createdAt"], value),
      });
    } else {
      // sortby Alphabetically
      this.setState({
        filings: orderBy(this.state.filings, ["companyName"], value),
        search: orderBy(this.state.search, ["companyName"], value),
      });
    }
  };

  Heading = ({ title, classes = "" }) => {
    const { sortSelection, sortBy } = this.state;
    const direction = sortSelection[title]?.direction;
    const iconAsc = "south";
    const iconAscClass =
      sortBy === title && direction && (direction === "asc" ? "active" : "");
    const iconDesc = "north";
    const iconDescClass =
      sortBy === title && direction && (direction === "desc" ? "active" : "");
    return (
      <th
        className={classes}
        role={"button"}
        onClick={() => this.handleSortBy(title)}
      >
        {title}
        <span className={`material-icons sort ${iconAscClass}`}>{iconAsc}</span>
        <span className={`material-icons sort ${iconDescClass}`}>
          {iconDesc}
        </span>
      </th>
    );
  };

  showDocument(filing, doc) {
    this.setState({ preview: { filing: filing, doc: doc } });
  }

  hideDocument() {
    this.setState({ preview: null });
  }

  searchFilings = (event) => {
    const { value } = event.target;

    const { filings } = this.state;

    if (!value.trim() || value.trim() === "") {
      // reset to all filings when search is empty
      this.setState({ search: filings });
      return;
    }

    const search = filings.filter(
      (filing) =>
        // search by company name OR document type
        filing.companyName.toLowerCase().includes(value.toLowerCase()) ||
        filing.documentFormatFiles.some((file) =>
          file.type.toLowerCase().includes(value.toLowerCase())
        )
    );

    this.setState({ search });
  };

  /* *** get react-bootstrap 4 tooltip *** */
  renderTooltip(message, id) {
    return <Tooltip id={`tooltip-${id}`}>{message}</Tooltip>;
  }

  /* *** get react-bootstrap 4 popover *** */
  renderPopover() {
    const { modalOpen, target, selectedItemId } = this.state;
    console.log(modalOpen, "TARGET::: ", target);

    return (
      <Overlay
        show={modalOpen}
        target={target}
        placement="left"
        container={this.divRef.current}
        containerPadding={20}
      >
        <Popover
          className="shadow-lg"
          id={`popover-${selectedItemId}`}
          style={{ maxWidth: "500px", minWidth: "470px" }}
        >
          <Popover.Title className="popover-title" as="h3">
            Select Document
            <button
              type="button"
              className="close text-white"
              aria-label="Close"
              onClick={() => this.setState({ modalOpen: false })}
              style={{
                background: "none",
                border: "none",
                fontSize: "1.25rem",
              }}
            >
              &times;
            </button>
          </Popover.Title>
          <Popover.Content>
            <div className="d-flex justify-content-start">
              {this.getDocumentFormatFiles()}
            </div>
          </Popover.Content>
        </Popover>
      </Overlay>
    );
  }

  render() {
    const { preview, isLoading, error, sortable, filedAt, search } = this.state;
    const { queryByFetch } = this.props;
    const { Heading } = this;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;

    const DateInput = forwardRef(({ value, onClick }, ref) => {
      return (
        <button
          className="btn btn-success-deal-style roundedEdges px-3 shadow "
          onClick={onClick}
          ref={ref}
        >
          {value}
          <span className="material-icons">expand_more</span>
        </button>
      );
    });

    return (
      <Fragment>
        <Header user={this.props.user} title={"BDC Dashboard"} />
        <Container className="MainContent bdc-dash">
          <Row className="mt-3 mb-3">
            <Col xs={12} className="mt-2 mb-2">
              <div className="sticky w-100 pb-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <InputGroup className="flex align-items-center">
                    <DatePicker
                      portalId="root-portal"
                      className="btn-block"
                      selected={moment(filedAt).toDate()}
                      onChange={(date) => {
                        this.setState(
                          {
                            filedAt: moment(date).format("YYYYMMDD"),
                          },
                          () => {
                            this.fetchBDCFilings();
                          }
                        );
                      }}
                      customInput={<DateInput />}
                    />

                    <div>
                      <select
                        className="form-select form-select-lg btn btn-success-deal-style roundedEdges px-3 py-2 ml-2 shadow"
                        onChange={(e) => {
                          this.sortDataByBtn(e.target.value);
                        }}
                        defaultValue={"null"}
                      >
                        <option value="null">Sort By</option>
                        <option value="asc">ASC</option>
                        <option value="desc">DESC</option>
                      </select>
                    </div>
                  </InputGroup>
                  <div className="col-md-3 mx-auto">
                    <input
                      type="text"
                      className="form-control roundedEdges w-100 shadow "
                      placeholder="Search here..."
                      onChange={this.searchFilings}
                    />
                  </div>
                </div>
              </div>

              {search.length ? (
                <Table style={{ width: "100%", marginTop: "5px" }}>
                  <thead className="responsive-th-optimized-search">
                    <tr>
                      <th>SR.</th>
                      <Heading
                        classes="text-left"
                        title="Accession No"
                        isSortable={sortable && true}
                      />
                      <Heading
                        classes="text-left"
                        title="Company"
                        isSortable={sortable && true}
                      />

                      <Heading
                        classes="text-inline"
                        title="CIK"
                        isSortable={sortable && true}
                      />
                      <Heading
                        classes="text-inline"
                        title="Filed At"
                        isSortable={sortable && true}
                      />

                      <th>Filing Time</th>

                      <Heading
                        classes="text-inline"
                        title="Fetched At"
                        isSortable={sortable && true}
                      />
                      <th className="text-left">Form</th>
                      <th className="text-left">Filing</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {search.map((filing, index) => {
                      let filingTime = moment(filing.filedAt)
                        .toDate()
                        .toLocaleTimeString("en-US", {
                          timeZone: "America/New_York",
                          hour: "2-digit",
                          minute: "2-digit",
                        });

                      return (
                        <tr key={index}>
                          <td>{++index}</td>
                          <td>{filing.accessionNo}</td>
                          <td>{filing.companyName}</td>
                          <td>{filing.cik}</td>
                          <td className="text-muted text-inline">
                            {moment(filing.filedAt.split("T")[0]).format(
                              "YYYY-MM-DD"
                            ) + " "}{" "}
                          </td>
                          <td>{filingTime}</td>
                          <td className="text-muted text-inline">
                            {filing.fetchedAtDate
                              ? moment(filing.fetchedAtDate).format(
                                  "YYYY-MM-DD"
                                )
                              : "n/a"}
                          </td>
                          <td>
                            {filing.documentFormatFiles &&
                              filing.documentFormatFiles
                                .filter(
                                  (item) =>
                                    item.type?.toLowerCase().includes("ex") ||
                                    item.type === filing.formType
                                )
                                .map((doc, index) => {
                                  return (
                                    <OverlayTrigger
                                      key={doc.documentId}
                                      overlay={this.renderTooltip(
                                        documentSize(doc.size),
                                        doc.documentId
                                      )}
                                    >
                                      <Button
                                        key={index}
                                        variant={"link"}
                                        size="sm"
                                        className="mr-1 documentClass"
                                        onClick={() => {
                                          this.showDocument(filing, doc);
                                        }}
                                      >
                                        {doc.type}{" "}
                                      </Button>
                                    </OverlayTrigger>
                                  );
                                })}
                          </td>

                          <td>
                            <OverlayTrigger
                              key={index}
                              placement="bottom"
                              trigger={["hover", "focus"]}
                              overlay={this.renderTooltip(
                                "Click to see document on SEC.gov.",
                                index
                              )}
                            >
                              <a
                                target="_blank"
                                rel="noreferrer"
                                className="documentClass"
                                href={`https://www.sec.gov/Archives/edgar/data/${
                                  filing.cik
                                }/${filing.accessionNo.replace(/-/gi, "")}/${
                                  filing.accessionNo
                                }-index.html`}
                              >
                                <span className="material-icons">launch</span>
                              </a>
                            </OverlayTrigger>
                          </td>

                          <td>
                            <div ref={this.divRef}>
                              <div id={`d_${index}`}>
                                {filing.formType === "N-54C" ? (
                                  <Button
                                    variant="default"
                                    className="documentClass"
                                    key={`mail_key_${filing.id}`}
                                    id={`mail_btn_${filing.id}`}
                                    onClick={(e) => this.handleOpenMail(filing)}
                                  >
                                    <EmailBoxIcon size={25} />
                                  </Button>
                                ) : (
                                  <Button
                                    variant="default"
                                    size="sm"
                                    className="documentClass"
                                    key={`key_${filing.id}`}
                                    id={`btn_${filing.id}`}
                                    onClick={(e) =>
                                      this.handleSelectedDocument(
                                        e,
                                        filing,
                                        false
                                      )
                                    }
                                  >
                                    <NotebookEditOutlineIcon size={25} />
                                  </Button>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div className="col-12">
                  <div className="row">
                    <Alert variant="info" className="mt-3 w-100">
                      <h4 className="mb-0">No items to show</h4>
                    </Alert>
                  </div>
                </div>
              )}
              {preview && (
                <FilingPreview
                  btnShow={true}
                  filing={preview.filing}
                  doc={preview.doc}
                  onDocumentClosed={() => this.hideDocument()}
                  selections={[]}
                  catalogue={[]}
                  onCatalogueAdd={this.props.onCatalogueAdd}
                  onCatalogueRemove={this.props.onCatalogueRemove}
                />
              )}
              {this.renderPopover()}
            </Col>
          </Row>
        </Container>
      </Fragment>
    ); /* *** end render return (main) *** */
  } /* *** end render function *** */
} /* *** end class *** */

Dashboard.propTypes = {};

export default withRouter(Dashboard);
